import SectionWrapper from "components/common/SectionWrapper";
import Link from "next/link";

const CallToAction: React.FC = ({}) => {
  return (
    <SectionWrapper className="mx-auto mt-16">
      <div
        className="relative w-full overflow-hidden rounded-3xl border border-primary-50/30 px-6 py-16 sm:py-20 text-center"
        style={{
          background:
            "radial-gradient(120% 160% at 50% 0%, rgba(126,92,255,0.35) 0%, rgba(56,42,254,0.15) 45%, rgba(7,7,11,0) 100%), #0B0B11",
        }}
      >
        <div className="absolute inset-0 bg-grid" aria-hidden="true" />
        <div className="relative z-10 flex flex-col items-center">
          <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-white max-w-2xl !leading-[1.15]">
            Have an idea? Let&apos;s make it{" "}
            <span className="text-gradient">real</span>.
          </h2>
          <p className="mt-4 max-w-xl text-zinc-400">
            Tell us what you&apos;re building — we&apos;ll bring the design,
            engineering, and product muscle to ship it.
          </p>
          <Link href={"#contact-us"}>
            <button className="mt-9 rounded-full bg-white text-[#0B0B10] font-heading font-semibold text-base px-8 py-3.5 hover:bg-primary-70 hover:shadow-[0_0_40px_rgba(126,92,255,0.5)] active:scale-95 duration-300 will-change-transform select-none cursor-pointer">
              Get started
            </button>
          </Link>
        </div>
      </div>
    </SectionWrapper>
  );
};

export default CallToAction;
